import { render, staticRenderFns } from "./EventOwnPaymentMethod.vue?vue&type=template&id=04a334d7&scoped=true"
import script from "./EventOwnPaymentMethod.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventOwnPaymentMethod.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./EventOwnPaymentMethod.vue?vue&type=style&index=0&id=04a334d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a334d7",
  null
  
)

export default component.exports